// eslint-disable-next-line ember/no-at-ember-render-modifiers
import didInsert from '@ember/render-modifiers/modifiers/did-insert';
// eslint-disable-next-line ember/no-at-ember-render-modifiers
import didUpdate from '@ember/render-modifiers/modifiers/did-update';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { loadGoogleMaps } from 'garaje/utils/script-loader';

interface GoogleMapsSignature {
  Args: {
    latitude: number | null | undefined;
    longitude: number | null | undefined;
  };
  Element: HTMLDivElement;
}

export default class GoogleMapsComponent extends Component<GoogleMapsSignature> {
  @tracked map: google.maps.Map | null = null;
  @tracked marker: google.maps.Marker | null = null;

  get latLng(): google.maps.LatLng | null {
    if (!window.google || this.args.latitude == null || this.args.longitude == null) {
      return null;
    }
    return new window.google.maps.LatLng(this.args.latitude, this.args.longitude);
  }

  handleDidInsert = (element: HTMLDivElement): void => {
    void this.insertMap(element);
  };

  handleLatLngChange = (): void => {
    const latLng = this.latLng;
    if (!latLng || !this.map || !this.marker) {
      return;
    }
    this.map.setCenter(latLng);
    this.marker.setPosition(latLng);
  };

  async insertMap(container: HTMLDivElement): Promise<void> {
    await loadGoogleMaps();

    if (this.isDestroying || this.isDestroyed) {
      return;
    }

    if (!window.google) {
      return;
    }

    const latLng = this.latLng;
    const options: google.maps.MapOptions = {
      zoom: 15,
      center: latLng,
      disableDefaultUI: true,
      draggable: false,
      scrollwheel: false,
      disableDoubleClickZoom: true,
    };

    this.map = new window.google.maps.Map(container, options);
    this.marker = new window.google.maps.Marker({
      position: latLng,
      map: this.map,
    });
  }

  <template>
    <div
      class="mapCanvas"
      style="width:100%;height:296px"
      {{didInsert this.handleDidInsert}}
      {{didUpdate this.handleLatLngChange this.latLng}}
      ...attributes
    ></div>
  </template>
}
